export const applyDisabledToOptions = (options = [], disabledIds = []) => {
  const normalizeSelectOptionId = (value) => {
    if (value === null || value === undefined) return '';
    return String(value);
  };

  const disabledIdSet = new Set(disabledIds.map((disabledId) => normalizeSelectOptionId(disabledId)));

  return options.map((option) => ({
    ...option,
    disabled: Boolean(option?.disabled) || disabledIdSet.has(normalizeSelectOptionId(option?.id)),
  }));
};
